'use strict';

module.exports = sbmv;

function sbmv () {
  console.error('SBMV (symmetric banded matrix vector multiply) not yet implemented');
}
